module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "md12": "",
      "sm12": ""
    }
  }, [(_vm.$root.activeMobileMenu) ? _c('v-icon', {
    staticClass: "btnIcon mr-2 ml-2",
    staticStyle: {
      "color": "#fff"
    },
    on: {
      "click": function($event) {
        _vm.closeMobileMenu()
      }
    }
  }, [_vm._v("arrow_back")]) : _vm._e(), _vm._v(" "), _c('img', {
    class: [_vm.$root.isRTL ? 'logoSmallRTL' : 'logoSmall'],
    attrs: {
      "src": require("../assets/yomanet.png")
    },
    on: {
      "click": function($event) {
        _vm.menuClick('Home')
      }
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "md1": ""
    }
  }, [_c('i', {
    staticClass: "material-icons icon w3-text-white",
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v("person")])]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "text-align": "right",
      "font-size": "16px",
      "padding": "5px 20px"
    },
    attrs: {
      "md11": ""
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$root.user.FullName) + "\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40b7d012"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Logo.vue
// module id = 881
// module chunks = 2